export default __webpack_public_path__ + "static/media/witheredsoul.0f0dc7af.png";